export default __webpack_public_path__ + "static/media/IMG_0691.13f81cac.jpeg";